// context/BookmarkContext.tsx
import React, { createContext, useContext } from "react";
import { IBookmark, useBookmark } from "../hooks/useBookmark";
import { IContact } from "../types/contacts";
import { useMessages } from "./MessagesContext";

interface IBookmarkContext {
  contactMarked: IContact[];
  favourites: IContact[];
  loading: boolean;
  createBookmark: (data: Partial<IBookmark>) => Promise<void>;
  deleteBookmark: (idUser: number, idContact: number) => Promise<void>;
  updateBookmark: (b: IBookmark) => Promise<void>;
}

const BookmarkContext = createContext<IBookmarkContext | null>(null);

export const BookmarkProvider = ({ children }: { children: React.ReactNode }) => {
  const { loading, createBookmark, deleteBookmark, updateBookmark } = useBookmark();
  const { favourites, contactMarked } = useMessages();
  return (
    <BookmarkContext.Provider
      value={{
        contactMarked,
        favourites,
        loading,
        createBookmark,
        deleteBookmark,
        updateBookmark,
      }}
    >
      {children}
    </BookmarkContext.Provider>
  );
};

export const useBookmarkContext = () => {
  const ctx = useContext(BookmarkContext);
  if (!ctx) throw new Error("useBookmarkContext must be used inside BookmarkProvider");
  return ctx;
};
